import React from "react";

export const Footer = () => {
  const date = new Date().getUTCFullYear();

  return (
    <>
      <footer>
        <div className="_footWrapper">
          <div className="ulBox">
            <h3>say hello</h3>

            <ul>
              <li>
                <a href="mailto:ficazzosam@gmail.com">hi@femiobadimu.dev</a>
              </li>
              <li>
                <a
                  href="https://femiobadimu.hashnode.dev/"
                  target="_blanket"
                  rel="noopener"
                >
                  blog.femiobadimu.dev
                </a>
              </li>
            </ul>
          </div>

          <div className="ulBox">
            <ul>
              <li>
                <a href="#projects">My Works</a>
              </li>
              <li>
                <a
                  href="https://github.com/femiobadimu"
                  target="_blanket"
                  rel="noopener"
                >
                  My Shelf
                </a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1bCQZ6GgXOwx712MIaEhX_wbJB6KFvP9Y/view?usp=share_link"
                  target="_blanket"
                  rel="noopener"
                >
                  My Résumé
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="_footBase">
          <span>&copy; Femi Obadimu {date}</span>

          <ul>
            <li>
              <a
                href="https://twitter.com/ficazzoS"
                target="_blanket"
                rel="noopener"
              >
                tw
              </a>
            </li>
            <li>
              <a
                href="https://github.com/femiobadimu"
                target="_blanket"
                rel="noopener"
              >
                gh
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/femi-obadimu-7021171b7"
                target="_blanket"
                rel="noopener"
              >
                ln
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};
